var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 20L25 14L19 8",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "left"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 13C3.58579 13 3.25 13.3358 3.25 13.75C3.25 14.1642 3.58579 14.5 4 14.5L4 13ZM24 13L4 13L4 14.5L24 14.5L24 13Z",
    fill: "white",
    className: "right"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnArrow);
export default __webpack_public_path__ + "static/media/btn-arrow.19e500fda03abb003325461b257eb571.svg";
export { ForwardRef as ReactComponent };